<template>
  <div>
    <CRow>
      <CCol>
        <CSelect
          label="Select Country"
          horizontal
          :options="this.$store.state.countries"
          placeholder="All"
          :value.sync="selcountryCode"
          size="sm"
        />
      </CCol>
      <CCol>
        <CSelect
          label="Select User"
          horizontal
          :options="users"
          placeholder="All"
          :value.sync="seluid"
          size="sm"
          v-if="this.$store.state.showSubNav.user"
        />
      </CCol>
      <CCol>
        <CSelect
          label="Select Business"
          horizontal
          :options="businesses"
          placeholder="All"
          :value.sync="selbid"
          size="sm"
          v-if="this.$store.state.showSubNav.business"
        />
      </CCol>
      <CCol>
        <CSelect
          label="Select Customer"
          horizontal
          :options="customers"
          placeholder="All"
          :value.sync="selcid"
          size="sm"
          v-if="this.$store.state.showSubNav.customer"
        />
      </CCol>
    </CRow>
    <CRow v-if="this.$store.state.showSubNav.date">
      <CCol>
        <CRow class="form-inline">
          <CCol md="auto">From</CCol>
          <CCol>
            <b-form-datepicker
              id="from"
              v-model="from"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
              }"
            ></b-form-datepicker>
          </CCol>
        </CRow>
      </CCol>
      <CCol>
        <CRow class="form-inline">
          <CCol md="auto">To</CCol>
          <CCol>
            <b-form-datepicker
              id="to"
              v-model="to"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
              }"
            ></b-form-datepicker>
          </CCol>
        </CRow>
      </CCol>
      <CCol></CCol>
      <CCol></CCol>
      <CCol></CCol>
    </CRow>
    <CButton @click="csv_clicked" color="primary" class="my-4"
      >CSV Export</CButton
    >
  </div>
</template>

<script>
import firebase from "firebase";

import { getDateLabel } from "../../common-functions.js";
import PageTitle from "./PageTitle.vue";

export default {
  name: "SubNav",
  components: { PageTitle },
  props: {
    csv_export: { type: Function },
  },
  data() {
    return {
      users: [{ value: "", label: "All" }],
      businesses: [{ value: "", label: "All" }],
      customers: [{ value: "", label: "All" }],

      selcountryCode: this.$store.state.selcountryCode,
      seluid: this.$store.state.seluid,
      selbid: this.$store.state.selbid,
      selcid: this.$store.state.selcid,

      from: this.$store.state.from ? this.$store.state.from : new Date(),
      to: this.$store.state.to ? this.$store.state.to : new Date(),
    };
  },

  watch: {
    selcountryCode: {
      immediate: true,
      handler(value) {
        this.$store.commit("set", ["selcountryCode", value]);
        this.seluid = "";
        this.selbid = "";
        this.selcid = "";
        this.loaddata("users");
      },
    },
    seluid: {
      immediate: true,
      handler(value) {
        this.$store.commit("set", ["seluid", value]);
        this.selbid = "";
        this.selcid = "";
        this.loaddata("businesses");
      },
    },
    selbid: {
      immediate: true,
      handler(value) {
        this.$store.commit("set", ["selbid", value]);
        this.selcid = "";
        this.loaddata("customers");
      },
    },
    selcid: {
      immediate: true,
      handler(value) {
        this.$store.commit("set", ["selcid", value]);
      },
    },
    from: {
      immediate: true,
      handler(value) {
        this.$store.commit("set", ["from", value]);
      },
    },
    to: {
      immediate: true,
      handler(value) {
        this.$store.commit("set", ["to", value]);
      },
    },
  },

  methods: {
    loaddata(type) {
      var db = firebase.firestore();

      if (type == "users") {
        if (!this.$store.state.showSubNav.user) return;
        //loading the user of selected country.
        this.users = [{ value: "", label: "All" }];
        if (this.selcountryCode == "") return;

        this.$store.commit("set", ["loading_user", true]);
        let ds = db.collection("users");
        ds = ds.where("countryNameCode", "==", this.selcountryCode);
        ds.orderBy("phoneNumber")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.users.push({
                label: doc.data().phoneNumber,
                value: doc.id,
              });
            });
            this.$store.commit("set", ["loading_user", false]);
          });
      } else if (type == "businesses") {
        if (!this.$store.state.showSubNav.business) return;
        //loading the business of selected user.
        this.businesses = [{ value: "", label: "All" }];
        if (this.seluid == "") return;

        this.$store.commit("set", ["loading_business", true]);
        db.collection("business")
          .where("uid", "==", this.seluid)
          .where("isDeleted", "==", false)
          .orderBy("name")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.businesses.push({
                label: doc.data().name,
                value: doc.id,
              });
            });
            this.$store.commit("set", ["loading_business", false]);
          });
      } else if (type == "customers") {
        if (!this.$store.state.showSubNav.customer) return;
        //loading the customers of selected business.
        this.customers = [{ value: "", label: "All" }];
        if (this.selbid == "") return;

        this.$store.commit("set", ["loading_customer", true]);
        var ref = db.collection("customer");
        if (this.seluid != "") ref = ref.where("uid", "==", this.seluid);
        if (this.selbid != "") ref = ref.where("bid", "==", this.selbid);
        ref
          .where("isDeleted", "==", false)
          .orderBy("name")
          .get()
          .then((querySnapshot) => {
            this.page = 0;
            //this.data = [];
            querySnapshot.forEach((doc) => {
              this.customers.push({
                label: doc.data().name,
                value: doc.id,
              });
            });
            this.$store.commit("set", ["loading_customer", false]);
          });
      }
    },
    csv_clicked() {
      //call csv_export function of parent component.
      this.csv_export();
    },
  },
};
</script>
